import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/context/LangContext";
import { api } from "@/lib/api";
import { ArrowRight, Leaf, Calendar } from "lucide-react";

const SeasonalStrip = () => {
  const { t, lang } = useLang();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/prodotti/stagionali").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data || !data.prodotti?.length) return null;
  const monthLabel = t(`month_${data.month}`);
  const pick = data.prodotti.slice(0, 8);

  return (
    <section data-testid="seasonal-strip" className="py-24 md:py-32 bg-carrubo text-pietra-light relative overflow-hidden">
      <div className="absolute inset-0 opacity-10 grain" />
      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <div className="eyebrow text-miele mb-4 flex items-center gap-2">
              <Calendar size={14} strokeWidth={1.8} />
              <span className="text-miele">{t("seasonal_eyebrow")} · {monthLabel}</span>
            </div>
            <h2 className="font-serif text-4xl md:text-6xl leading-[1.05] mb-6">
              {t("seasonal_title")}
            </h2>
            <p className="text-lg text-pietra-light/85 leading-relaxed">{t("seasonal_intro")}</p>
          </div>
          <Link to="/prodotti" data-testid="seasonal-cta"
            className="inline-flex items-center gap-3 text-miele hover:text-pietra-light group self-start md:self-end">
            <span className="small-caps">{t("seasonal_cta")}</span>
            <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {pick.map((p) => (
            <Link key={p.slug} to={`/prodotti/${p.slug}`}
              data-testid={`seasonal-card-${p.slug}`}
              className="group relative overflow-hidden rounded-sm border border-miele/20 hover:border-miele bg-carrubo-dark transition-all">
              <div className="aspect-square overflow-hidden">
                <img loading="lazy" decoding="async" src={p.image} alt="" className="w-full h-full object-cover opacity-90 group-hover:opacity-100 group-hover:scale-105 transition-all duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-carrubo-dark via-transparent to-transparent" />
              </div>
              <div className="absolute top-3 right-3 bg-miele text-grafite text-[0.6rem] font-bold uppercase tracking-widest px-2 py-1 rounded-sm flex items-center gap-1">
                <Leaf size={10} strokeWidth={2.4} /> {t("prodotti_in_season")}
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <div className="small-caps text-miele mb-1 text-[0.55rem]">{t(`cat_${p.category}`)}</div>
                <div className="font-serif text-lg leading-tight">{p.name}</div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-xs text-pietra-light/60 italic">
          {lang === "it"
            ? `${data.count} prodotti in stagione a ${monthLabel}.`
            : `${data.count} products in season in ${monthLabel}.`}
        </div>
      </div>
    </section>
  );
};

export default SeasonalStrip;
